import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=ec48c1e8&scoped=true&"
import script from "./BankAccountList.vue?vue&type=script&lang=js&"
export * from "./BankAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec48c1e8",
  null
  
)

export default component.exports